export default "__VITE_ASSET__bf22a9aa__"